const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');

const initialState = Immutable.fromJS({
    ...(__CONTACT_CENTER__ ? {
        agreementChecked: true,
        agreementIsDirty: false,
        valid: true,
    } : {
        agreementChecked: false,
        agreementIsDirty: false,
        valid: false
    })
});

function validateStep(state) {
    if (__CONTACT_CENTER__) {
        return state;
    }

    return state.merge({
        valid: state.get('agreementChecked'),
        agreementIsDirty: true
    });
}

function hireCardRevolvingStep5(state = initialState, action = { type: null }) {
    switch (action.type) {
        case actionTypes.HIRE_CARD_REVOLVING_VALIDATE_STEP:
            return validateStep(state);

        case actionTypes.HIRE_CARD_REVOLVING_SET_AGREEMENT_CHECKBOX:
            return state.merge({
                agreementChecked: action.payload.checked,
                agreementIsDirty: false
            });

        default:
            return state;
    }
}

module.exports = hireCardRevolvingStep5;
